import symptomsIndex from "../symptom lists/symptomsIndex"

const symptomHandler = {
 createSymptomObject:(symptom)=> 
    {
    const symptomsReturnObject={
    symptomText:"",
    symptomQuestionGroup:""
    }
    for (let symptomGroup of symptomsIndex)
        {
        for (let eachSymptom of symptomGroup[0])
            {
            if (symptom === eachSymptom["symptom"])
                {  
                symptomsReturnObject.symptomText=eachSymptom.displayAs
                if (typeof eachSymptom.questionGroup != 'undefined' &&  eachSymptom.questionGroup != null)
                    {
                    symptomsReturnObject.symptomQuestionGroup=eachSymptom.questionGroup
                    }
                else
                 {
                symptomsReturnObject.symptomQuestionGroup=[]
                 }

                return symptomsReturnObject
                }
            }
        }
    },

initialValuesBuilder:(questions)=>
    {
    let newObject={}
    questions.forEach(item => {
    
        let label=item["label"]
        let labelNoWhitespace= label.replaceAll(" ","_")
        if (item["controlType"] === "checkbox group")
            {
            newObject[labelNoWhitespace]=[] //initailise array to recieve multiple values if checkbox gropu
            }
        else 
            {
             newObject[labelNoWhitespace]="" //otherwise initialise string
            }
        })
    return newObject
    },


ListOptions:(optionsArray, control)=>
    { //generates option lists for modal symptom form items
    let options=[]

    if (control==="dropdown")
        {
        options.push({key:"Select an option", value: ""})
        }
    
    optionsArray.forEach(item=>
        {
        let newEntry = {key:item, value:item}
        options.push(newEntry)
        })
    return options
    },
}

export default symptomHandler